/**
 * description:
 * dateTime: 2024/8/20-下午5:51
 * author: ZhangJun 1580043700@qq.com
 */
import {SFuncModal} from "shj-components";
import {Flex, Form, Input, InputNumber, TreeSelect} from "antd";
import {useEffect, useMemo} from "react";
import {useRequest} from "ahooks";
import {queryMemberEquityCategoryList, saveOrUpdateMemberLevel} from "@/services/member.ts";

type EditOption = {
    title: string,
    data?: any
    destroy: (success: boolean) => void;
}

export function openEdit(option: EditOption) {
    const destroy = (success) => {
        modal.destroy();
        option.destroy(success)
    }
    const modal = SFuncModal({
        content: (<EditContent destroy={destroy} data={option.data}/>),
        title: option.title,
        vanish: true,
    });
}

const formatTree = (treeData: Array<any>, keyName = '') => {
    return (treeData || []).map((item) => {
        const list = item['childList'] || item['memberEquityList'];
        return {
            ...item,
            disabled: keyName != 'memberEquityList',
            children: list?.length ? formatTree(list, item['memberEquityList'] ? 'memberEquityList' : '') : []
        };
    });
}

function EditContent(props: any) {

    const [form] = Form.useForm();

    const {loading, runAsync} = useRequest(saveOrUpdateMemberLevel, {manual: true});
    const {data: runMemberList,}: any = useRequest(queryMemberEquityCategoryList, {defaultParams: [{}]});

    const memberEquityIdList = useMemo(() => formatTree(runMemberList || []), [runMemberList]);

    useEffect(() => {
        form.resetFields();
        const data = props.data || {}
        form.setFieldsValue({
            ...data,
            memberEquityIdList: (data.memberEquities || []).map(item => item?.id)
        });
    }, [props.data])

    const onOk = () => {
        form.validateFields().then(values => {
            runAsync({...props.data, ...values}).then(() => {
                props.destroy(true)
            })
        })
    }

    return (
        <SFuncModal.Content onOk={onOk} onCancel={() => props.destroy(false)} confirmLoading={loading} >
            <Form form={form} layout='vertical'>
                <Form.Item label='等级编码' name='type' rules={[{required: true}]}>
                    <Input maxLength={50} disabled={props.data?.id}/>
                </Form.Item>
                <Form.Item label='等级名称' name='name' rules={[{required: true}]}>
                    <Input maxLength={11}/>
                </Form.Item>
                <Form.Item label='成长值区间' required>
                    <Flex align='center'>
                        <Form.Item noStyle name='growValueLowerLimit'
                                   rules={[{required: true, message: '请输入成长值区间'}]}>
                            <InputNumber min={0} precision={0} style={{width: '100%'}}/>
                        </Form.Item>
                        <div style={{margin: '0 10px'}}>至</div>
                        <Form.Item shouldUpdate noStyle>
                            {
                                (instance) => (
                                    <Form.Item noStyle name='growValueCapLimit'>
                                        <InputNumber min={(instance.getFieldValue("growValueLowerLimit") || 0) + 1}
                                                     precision={0} style={{width: '100%'}}/>
                                    </Form.Item>
                                )
                            }
                        </Form.Item>
                    </Flex>
                </Form.Item>
                <Form.Item label='关联权益' name='memberEquityIdList' rules={[{required: true}]}>
                    <TreeSelect
                        showSearch
                        allowClear
                        placeholder='请选择关联权益'
                        treeDefaultExpandAll
                        treeCheckable
                        treeData={memberEquityIdList}
                        fieldNames={{label: 'name', value: 'id'}}></TreeSelect>
                </Form.Item>
            </Form>
        </SFuncModal.Content>
    )
}

